import { render, staticRenderFns } from "./VacantJob.vue?vue&type=template&id=1aab6973&"
import script from "./VacantJob.vue?vue&type=script&lang=js&"
export * from "./VacantJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports